import { render, staticRenderFns } from "./NuevoEmail.vue?vue&type=template&id=4509a012&scoped=true&"
import script from "./NuevoEmail.vue?vue&type=script&lang=js&"
export * from "./NuevoEmail.vue?vue&type=script&lang=js&"
import style0 from "./NuevoEmail.vue?vue&type=style&index=0&id=4509a012&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4509a012",
  null
  
)

export default component.exports